module.exports = __webpack_public_path__ + "static/assets/1fe34b0c9fdab5c88776ce67281254b1.png";